import { supabaseClient } from "@/lib/database/supabase";
import { Court } from "@shared/lib/database/query.types";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

export default defineStore("CommissionerCourtStore", () => {
  const commissionerCourts = ref<Array<Court>>([]);

  const sortedCommissionerCourts = computed(() => {
    return [...commissionerCourts.value].sort((a, b) => a.name.localeCompare(b.name));
  });

  function addCommissionerCourt (court: Court) {
    if (commissionerCourts.value.some((_court) => _court.id === court.id)) return;

    commissionerCourts.value.push(court);
  }

  function removeCommissionerCourt (court: Pick<Court, "id">) {
    commissionerCourts.value = commissionerCourts.value.filter((_court) => _court.id !== court.id);
  }

  function updateCommissionerCourts (courts: Array<Court>) {
    commissionerCourts.value = courts;
  }

  async function fetchCommissionerCourts () {
    const {
      data: courts,
    } = await supabaseClient.rpc("get_commissioner_courts")
      .throwOnError();

    commissionerCourts.value = courts;

    return courts;
  }

  return {
    commissionerCourts: sortedCommissionerCourts,
    addCommissionerCourt,
    removeCommissionerCourt,
    updateCommissionerCourts,
    fetchCommissionerCourts,
  };
});
